import styled from 'styled-components'
import { BannerComponent } from 'Pages/landings/newLandings/common/components'
import { media, Breakpoints, themeObject } from 'Pages/landings/newLandings/common/style'
import { Button } from 'Pages/landings/newLandings/common/components/Button/styled'

export const Banner = styled(BannerComponent)`
	height: auto;
	background-position: right;
	${media('padding-right: 48%;', Breakpoints.ms)};
	${media('padding-right: 40%;', Breakpoints.lx)};
	${media('padding-right: 50%;', Breakpoints.xl)};
	${Button} {
		@media (max-width: 767px) {
			color: ${themeObject.colors.base.white};
			background: ${themeObject.colors.brand[500]};
			&:disabled {
				color: ${themeObject.colors.grey[300]};
				background: ${themeObject.colors.grey[100]};
			}
			&:hover {
				background: ${themeObject.colors.brand[600]};
			}
			&:active {
				background: ${themeObject.colors.brand[700]};
			}
			&:focus {
				background: ${themeObject.colors.brand[500]};
				box-shadow: 0 0 0 4px ${themeObject.colors.brand[200]};
			}
		}
	} ;
`
